(() => {
  const logo = document.querySelector('.om-home .om-logo');
  if (!logo || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const clearPending = () => { document.documentElement.classList.remove('om-reveal-pending'); clearTimeout(window.orbitRevealFallback); };
  const ease = value => { const t = Math.max(0, Math.min(1, value)); return t * t * t * (t * (t * 6 - 15) + 10); };
  const prepare = logo => {
    if (!logo.isConnected) return;
    const box = logo.getBoundingClientRect();
    const style = getComputedStyle(logo);
    const pad = Math.min(24, box.left, Math.max(0, innerWidth - box.right)), width = Math.ceil(box.width + pad * 2), height = Math.ceil(box.height + pad * 2);
    const dpr = Math.min(devicePixelRatio || 1, 3);
    const mask = document.createElement('canvas');
    mask.width = Math.ceil(width * dpr); mask.height = Math.ceil(height * dpr);
    const ink = mask.getContext('2d');
    if (!ink) return;
    ink.scale(dpr, dpr);
    ink.font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
    ink.letterSpacing = style.letterSpacing;
    ink.textBaseline = 'alphabetic';
    const runs = logo.matches('.om-clock') ? [...logo.querySelector('[data-om-clock-value]').children] : [logo];
    for (const run of runs) {
      const text = run.textContent;
      const marker = document.createElement('i');
      marker.setAttribute('aria-hidden', 'true');
      marker.style.cssText = 'display:inline-block;width:0;height:0;padding:0;margin:0;border:0;vertical-align:baseline;';
      run.append(marker);
      const baseline = pad + marker.getBoundingClientRect().top - box.top;
      marker.remove();
      const left = run.getBoundingClientRect().left - box.left;
      ink.fillText(text, pad + left, baseline);
    }
    const pixels = ink.getImageData(0, 0, mask.width, mask.height).data;
    const dots = [];
    const step = 1.5;
    for (let y = 0; y < height; y += step) for (let x = 0; x < width; x += step) {
      const px = Math.min(width - 1 / dpr, x + Math.random() * step);
      const py = Math.min(height - 1 / dpr, y + Math.random() * step);
      if (pixels[(Math.floor(py * dpr) * mask.width + Math.floor(px * dpr)) * 4 + 3] > 100) {
        const angle = Math.random() * Math.PI * 2;
        const distance = 8 + Math.random() * 14;
        dots.push({x: px, y: py, dx: Math.cos(angle) * distance, dy: Math.sin(angle) * distance, delay: Math.random() * .16, duration: .62 + Math.random() * .16, bend: (Math.random() - .5) * 5, radius: step * (.28 + Math.random() * .18)});
      }
    }
    const canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.width = width * dpr; canvas.height = height * dpr;
    canvas.style.cssText = `position:absolute;left:-${pad}px;top:-${pad}px;width:${width}px;height:${height}px;pointer-events:none;`;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.scale(dpr, dpr);
    const color = getComputedStyle(logo.closest('.om')).color;
    const previousColor = logo.style.color, previousPosition = logo.style.position;
    logo.style.position = 'relative'; logo.style.color = 'transparent'; logo.append(canvas);
    const finish = () => { canvas.remove(); logo.style.color = previousColor; logo.style.position = previousPosition; };
    const frame = t => {
      if (t >= 1 || document.hidden) { finish(); return; }
      ctx.clearRect(0, 0, width, height);
      ctx.fillStyle = color;
      const blend = ease((t - .40) / .55);
      logo.style.color = `color-mix(in srgb, ${color} ${blend * 100}%, transparent)`;
      ctx.globalAlpha = ease(t / .24) * (1 - blend);
      ctx.beginPath();
      for (const p of dots) {
        const progress = ease((t - p.delay) / p.duration);
        const remaining = 1 - progress;
        const curve = 4 * progress * remaining * p.bend;
        const distance = Math.hypot(p.dx, p.dy);
        const x = p.x + p.dx * remaining - p.dy / distance * curve;
        const y = p.y + p.dy * remaining + p.dx / distance * curve;
        ctx.moveTo(x + p.radius, y);
        ctx.arc(x, y, p.radius, 0, Math.PI * 2);
      }
      ctx.fill();
      ctx.globalAlpha = 1;
    };
    return {frame, finish};
  };
  const start = async () => {
    if (document.readyState === 'loading') await new Promise(resolve => document.addEventListener('DOMContentLoaded', resolve, {once:true}));
    await document.fonts.ready;
    const targets = [logo, document.querySelector('.om-home .om-clock')].filter(Boolean);
    const animations = targets.map(prepare).filter(Boolean);
    let previous;
    let elapsed = 0;
    clearTimeout(window.orbitRevealFallback);
    const frame = now => {
      if (previous !== undefined) elapsed += Math.min(now - previous, 40);
      previous = now;
      const progress = elapsed / 4500;
      if (progress >= 1 || document.hidden) {
        animations.forEach(animation => animation.finish());
        clearPending();
        return;
      }
      animations.forEach(animation => animation.frame(progress));
      requestAnimationFrame(frame);
    };
    requestAnimationFrame(frame);
  };
  start().catch(clearPending);
})();

